export const INSERT = "insert";
export const INITIALISE = "initialise";
export const FETCH_AD = "FETCH_AD";
export const FILTER_AD = "FILTER_AD";
export const MY_AD = "MY_AD";
export const FOLLOWED_AD = "FOLLOWED_AD";
export const startLoading = () => ({ type: 'START_LOADING' });
export const stopLoading = () => ({ type: 'STOP_LOADING' });
